import { IBondGelemMarketReport } from 'services/bonds-helper';

export const PREFIX = 'REPORT_DELTA_LINKED_MARKET';

export type IReportDeltaLinkedMarketItem = IBondGelemMarketReport & { __isSelected: boolean };
